"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./integrations"), exports);
__exportStar(require("./modules"), exports);
__exportStar(require("./Account"), exports);
__exportStar(require("./Button"), exports);
__exportStar(require("./Media"), exports);
__exportStar(require("./Page"), exports);
__exportStar(require("./Theme"), exports);
__exportStar(require("./User"), exports);
__exportStar(require("./Module"), exports);
__exportStar(require("./Wizard"), exports);
__exportStar(require("./SignupFormValues"), exports);
/*
  export interface PageStats {
    // totals
    visitors: number; // total visitors
    views: number; // total page views
    clicks: number; // total links clicked
  }
  
  export interface LinkClick {
    date: Date;
    path: string; // page path or url?
  }
  
  export interface PageView {
    data: Date;
    remoteIp: string; // use this for unique visits
    path: string; // the page path
  }
  */
//# sourceMappingURL=index.js.map